import { useState } from "react";
import Input from '../../Input';
import { FiUser } from 'react-icons/fi';
import Button from '../../Button';
function CompetitionUsersAdded( {indexId, users, onRemoveUser}) {
  const [search, setSearch] = useState("");  
  const [removingUserId, setRemovingUserId] = useState(null);

  // console.log("users w komponencie:", users);
  //   console.log("tablica:", Array.isArray(users));
  const filteredUsers = users.filter((user) =>
    
    user.shop_name.toLowerCase().includes(search.toLowerCase()) ||
    user.Name.toLowerCase().includes(search.toLowerCase()) ||
    user.user_id.includes(search)
  );

   const handleRemove = async (userId) => {
    const confirmed = window.confirm(
      "Czy na pewno chcesz usunąć tego użytkownika przypisanego do indeksu?"
    );

    if (!confirmed) return;

    try {
      setRemovingUserId(userId);

      await onRemoveUser(userId, indexId);
    } catch (error) {
      console.error("Błąd podczas usuwania użytkownika:", error);
      alert("Nie udało się usunąć użytkownika.");
    } finally {
      setRemovingUserId(null);
    }
  };
  return (
    <div>
        

      {filteredUsers.length === 0 ? (
        <div class="
 bg-white



 text-center
 text-gray-400
 text-sm
 ">Brak przypisanych użytkowników</div>
      ):(
        <div>
                 <Input label="Szukaj użytkownika, sklepu lub produktu" value={search} onChange={e => setSearch(e.target.value)} size="small" className="w-full mb-2 text-xs" fullWidth placeholder="Wprowadź dane..." />

   <div className="max-h-[500px] overflow-y-auto">

          {filteredUsers.map((filteredUsers, index) => (
            <div
            key={index}
            className="
                bg-white
                border
                border-gray-200
                rounded
                p-3
                mb-1
                hover:shadow-sm
                transition-shadow
            "
        >

            <div className="
                flex
                items-center
                justify-between
            ">

                <div className="flex flex-col min-w-0">

<div className="grid gap-2">
  
    <div className="flex items-center gap-1">
         <FiUser 
                    size={16}
                    className="text-gray-400"
                />
        <span className="text-xs font-semibold text-gray-900 truncate">
            {filteredUsers.shop_name}
        </span>
         <span className="text-xs font-medium text-gray-500">-</span>
        <span className="text-xs text-gray-900 truncate">
            {filteredUsers.client_email}
        </span>
    </div>

   
</div>
                   


                 

                </div>



               

 <Button
                    className="h-fit self-end sm:w-auto"
                    variant="contained"
                    size="small"
                    disabled={removingUserId === filteredUsers.user_id}
                    onClick={() => handleRemove(filteredUsers.user_id)}
                  >
                    {removingUserId === filteredUsers.user_id
                      ? "Usuwanie..."
                      : "Usuń"}
                  </Button>
            </div>



        </div>
       
          ))}
        </div>
         </div>
      )}
    </div>
  );
}

export default CompetitionUsersAdded;